module.exports = __webpack_public_path__ + "media/public/images/social/instagram-988073651967ab210c870175cbafb72b.svg";